export default __webpack_public_path__ + "static/media/nick.f0adf99f.webp";